import { FC } from 'react'
import { useTranslation } from 'react-i18next'

interface Props {
  vat?: boolean
}

const Vat: FC<Props> = ({ vat }) => {
  const { t } = useTranslation('company')

  return (
    <div>
      {t('company:form.fields.vat')} {t(`company:form.prepaymentValues.${vat ? 'yes' : 'no'}`)}
    </div>
  )
}

export default Vat
